/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateMultiUserWidgetScenarioRequest = {
    daysAhead?: number;
    categoryName?: string;
    subUserTherapistName?: string;
    /**
     * When true, the manager therapist also gets a weekly bookable rule on the shared category.
     */
    createManagerRule?: boolean;
    /**
     * When true, creates an additional subuser-owned public category with its own rule.
     */
    createSubUserOwnedCategory?: boolean;
    subUserOwnedCategoryName?: string;
    /**
     * Optional location override on the subuser inherited category row (e.g. virtual).
     */
    subUserLocationOverride?: CreateMultiUserWidgetScenarioRequest.subUserLocationOverride;
};
export namespace CreateMultiUserWidgetScenarioRequest {
    /**
     * Optional location override on the subuser inherited category row (e.g. virtual).
     */
    export enum subUserLocationOverride {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
        NOT_FIXED = 'not-fixed',
    }
}

